import { createReducer } from 'utils'
import { fromJS } from 'immutable'

import { constants } from 'common/actions/user'
import { RESET_ERROR } from 'common/actions/error'

export const initialState = fromJS({
  isSubmitting: false,
  error: null
})

export default createReducer(initialState, {
  [RESET_ERROR]: state => state.set('error', null),

  [constants.ADD_SYSTEM_TO_USER_REQUEST.START]: state => state.set('isSubmitting', true),
  [constants.ADD_SYSTEM_TO_USER_REQUEST.SUCCESS]: () => initialState,
  [constants.ADD_SYSTEM_TO_USER_REQUEST.FAILURE]: (state, { payload: error }) => {
    return state.set('isSubmitting', false).set('error', error)
  }
})
